<ion-header class="modal-header">
  <div class="modal-title">
    <h3>Working Hours</h3>
    <ion-button (click)="workingHours.enabled = !workingHours.enabled" fill="clear">
      <ion-icon [name]="workingHours.enabled ? 'checkbox' : 'square-outline'" class="padded-icon"></ion-icon>
      Enabled
    </ion-button>
  </div>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button fill="clear" shape="round" class="close-button" (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-card class="outline-card" style="margin: 15px">
    <ion-item>
      <ion-label>Timezone</ion-label>
      <ion-select class="select-outline" interface="popover" [(ngModel)]="timezone" placeholder="Select timezone">
        <ion-select-option *ngFor="let tz of timezoneOptions" [value]="tz">
          {{ tz }}
        </ion-select-option>
      </ion-select>
    </ion-item>
    <ion-list style="padding: 0">
      <ion-item *ngFor="let day of daysOfWeek; let i = index" [disabled]="!workingHours.enabled">
        <ion-label slot="start" style="max-width: 88px">
          {{ day.display }}
        </ion-label>
        <ion-select
          class="select-outline"
          interface="popover"
          [(ngModel)]="day.startInterval"
          placeholder="Select"
          slot="end"
        >
          <ion-select-option *ngFor="let time of timesOfDay" [value]="time.minutes + day.index * 60 * 24">
            {{ time.display }}
          </ion-select-option>
        </ion-select>
        <ion-select
          class="select-outline"
          interface="popover"
          [(ngModel)]="day.endInterval"
          placeholder="Select"
          slot="end"
        >
          <ion-select-option *ngFor="let time of timesOfDay" [value]="time.minutes + day.index * 60 * 24">
            {{ time.display }}
          </ion-select-option>
        </ion-select>
        <ion-button fill="clear" slot="end" color="danger" (click)="deleteOperationHours(i)">
          <ion-icon name="close-outline"></ion-icon>
        </ion-button>
      </ion-item>
    </ion-list>
  </ion-card>
  <ion-button fill="clear" (click)="addOperationHours()" style="margin: 3px 12px" [disabled]="!workingHours.enabled">
    <ion-icon name="add-outline" class="padded-icon"></ion-icon>Add hours
  </ion-button>

  <!-- Holidays Section -->
  <ion-card class="outline-card" style="margin: 15px">
    <ion-card-header>
      <ion-label>Holidays ({{ workingHours.holidays?.length ?? 0 }})</ion-label>
    </ion-card-header>
    <ion-list style="padding: 0">
      <div *ngFor="let holiday of workingHours.holidays; let i = index" class="holiday-item-container">
        <ion-item [disabled]="!workingHours.enabled" lines="none">
          <ion-input [(ngModel)]="holiday.name" placeholder="Enter holiday name" style="max-width: 300px"></ion-input>
          <ion-button
            color="dark"
            fill="clear"
            (click)="setHolidayDate(holiday, 'startDate')"
            class="btn-small button-dark-border"
          >
            <span *ngIf="holiday.startDate">{{ holiday.startDate | date: 'M/d/yyyy' }}</span>
            <span *ngIf="!holiday.startDate">Select start date</span>
          </ion-button>
          <ion-button
            color="dark"
            fill="clear"
            (click)="setHolidayDate(holiday, 'endDate')"
            class="btn-small button-dark-border"
          >
            <span *ngIf="holiday.endDate">{{ holiday.endDate | date: 'M/d/yyyy' }}</span>
            <span *ngIf="!holiday.endDate">Select end date</span>
          </ion-button>
          <ion-button fill="clear" slot="end" color="danger" (click)="deleteHoliday(i)">
            <ion-icon name="close-outline"></ion-icon>
          </ion-button>
        </ion-item>
      </div>
    </ion-list>
  </ion-card>
  <ion-button fill="clear" (click)="addHoliday()" style="margin: 3px 12px" [disabled]="!workingHours.enabled">
    <ion-icon name="add-outline" class="padded-icon"></ion-icon>Add holiday
  </ion-button>
</ion-content>

<ion-footer class="footer flex-space-between">
  <ion-button (click)="save()" [disabled]="isLoading">
    <span [hidden]="isLoading">Save</span>
    <ion-spinner name="crescent" [hidden]="!isLoading"></ion-spinner>
  </ion-button>
</ion-footer>
